
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/integrations/interoperability",
      function () {
        return require("private-next-pages/material-ui/integrations/interoperability.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/integrations/interoperability"])
      });
    }
  